import type { DocMigration } from "../docMigration";

function isFormula(v: any) {
  return !!v && typeof v === "object" && v.hasOwnProperty("type") && v.type === "FORMULA";
}

function migrateEaveType(oldEaveType: string): string {
  switch (oldEaveType) {
    case "BOX":
      return "BOXED_BOX";
    case "OPEN":
      return "BOXED_OPEN";
    case "MINI_HIP":
      return "BOXED_MINI_HIP";
    case "MINI_SHED":
      return "BOXED_MINI_SHED";
    case "FULL_RETURN":
      return "BOXED_FULL_RETURN";
    case "EXPOSED_RAFTERS":
      return "ANGLED_OPEN_OPEN";
  }

  return "BOXED_BOX";
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_101: DocMigration = {
  maxSchemaVersion: "0.0.101",
  description: "New eave types and adjusted heel height offset",
  apply(json: any) {
    const roofOffsetZ = 2.5;

    // roof settings
    for (const settingsId in json.settings) {
      const settings = json.settings[settingsId];
      if (settings.type !== "ROOF_SETTINGS") {
        continue;
      }

      if (settings.fasciaTrimThickness) {
        settings.fasciaTrimSize = settings.fasciaTrimThickness;
        delete settings.fasciaTrimThickness;
      }

      if (settings.eaveType) {
        settings.eaveType = migrateEaveType(settings.eaveType);
      }
    }

    // roof systems
    for (const roofId in json.roofs) {
      const roof = json.roofs[roofId];

      if (roof.eaveType) {
        roof.eaveType = migrateEaveType(roof.eaveType);
      }

      if (roof.heelHeightOffset) {
        if (isFormula(roof.heelHeightOffset)) {
          roof.heelHeightOffset.formula = `(${roof.heelHeightOffset.formula}) - ${roofOffsetZ}`;
        } else {
          roof.heelHeightOffset -= roofOffsetZ;
        }
      } else {
        roof.heelHeightOffset = -roofOffsetZ;
      }

      if (roof.rightHeelHeightOffset) {
        if (isFormula(roof.rightHeelHeightOffset)) {
          roof.rightHeelHeightOffset.formula = `(${roof.rightHeelHeightOffset.formula}) - ${roofOffsetZ}`;
        } else {
          roof.rightHeelHeightOffset -= roofOffsetZ;
        }
      }

      const dormers = roof.dormers;

      if (dormers && dormers.eaveType) {
        dormers.eaveType = migrateEaveType(dormers.eaveType);
      }
    }

    return json;
  },
};

export default migration_0_0_101;
